import { render } from "./Error.vue?vue&type=template&id=64ca554a"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
script.render = render

export default script